import { Environment } from '@instaclause-webapp/shared-core';

export const environment: Omit<
  Environment,
  'integrationsBaseUrl' | 'exactClientId' | 'exactRegion' | 'adminPulseClientId'
  | 'hubSpotClientId'
  | 'accountantBaseUrl'
> = {
  production: false,
  apiBaseUrl: '/api',
  apiAuthUrl: 'https://admin.staging.instaclause.com/api',
  docsBaseUrl: 'https://documents.staging.instaclause.com',
  appName: 'expert',
  version: '2.0.0-beta.18-rc.1',
  amplitudeApiKey: '3322e7baf2380ae53ff8892d0853b286',
  googleSignInClientId: '1016885070607-l1opuebubanqmh8sn88memm6hvlktueq.apps.googleusercontent.com',
  entraClientId: '5883619e-8dea-4d24-8e7f-d7d88acecf13',
  docusignClientId: '',
  docusignAuthServer: '',
  faroUrl: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/712c9418ab7f78df6e9edf167e453b99',
};
